import { SVGProps } from 'react'

function UserSelfieFirst(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12 14.25a3.375 3.375 0 1 0 0-6.75 3.375 3.375 0 0 0 0 6.75Z"
        stroke="#F5963D"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.08 18.5a6.066 6.066 0 0 0-10.16 0M12 .75v.75M20.242 3.758l-.817.817M23.25 12h-.75M19.955 19.955l-.53-.53M12 23.25v-.75M4.045 19.955l.53-.53M.75 12h.75M4.045 4.045l.53.53"
        stroke="#F5963D"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M12 20.25a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5Z"
        stroke="#F5963D"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

UserSelfieFirst.defaultProps = { role: 'graphics-document' }

export default UserSelfieFirst
